import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { connect } from '../../../react-redux';
import { PrintTrigger as PrintTriggerPresenter } from './presenter';
import { PRINT_FONT_SIZE_MODAL, QUIZ_SESSION_GRADE_SCOPE } from '@instructure/quiz-common';
import * as printingActions from '../../../actions/printing';
import * as modalActions from '../../../actions/modal';
import * as quizEntriesApiActions from '../../../../building/api/quizEntries';
import { getConfigTokenScope } from '../../../selectors/config';
export function mapStateToProps(state) {
  return {
    activeQuizId: state.getIn(['quizzes', 'activeQuizId']),
    appContainer: state.getIn(['ui', 'appContainer']),
    bankQuizEntryIds: state.get('quizEntries', Map()).filter(function (quizEntry) {
      return quizEntry.get('entryType') === 'Bank';
    }).keySeq().toArray(),
    isGrading: getConfigTokenScope(state) === QUIZ_SESSION_GRADE_SCOPE,
    printFontSizeModalOpen: state.getIn(['modal', 'isOpen']) === PRINT_FONT_SIZE_MODAL,
    persistedPrintFontSize: state.getIn(['printing', 'fontSizePreference'])
  };
}
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openPrintFontSizeModal: bindActionCreators(modalActions.openModal.bind(modalActions, PRINT_FONT_SIZE_MODAL), dispatch),
    closePrintFontSizeModal: bindActionCreators(modalActions.closeModal.bind(modalActions, PRINT_FONT_SIZE_MODAL), dispatch),
    persistPrintFontSize: bindActionCreators(printingActions.persistPrintFontSizePreference.bind(printingActions), dispatch),
    setPrintFontSize: bindActionCreators(printingActions.setPrintFontSizePreference.bind(printingActions), dispatch),
    getSampleItemsForQuizEntry: bindActionCreators(quizEntriesApiActions.getSampleItemsForQuizEntry.bind(quizEntriesApiActions), dispatch)
  };
};
export var PrintTrigger = connect(mapStateToProps, mapDispatchToProps)(PrintTriggerPresenter);
export default PrintTrigger;